export default {
  'constants.yes': 'Yes',
  'constants.no': 'No',
};
